class YTScripts {
    constructor() {
        this.players = {};
        this.attempts = 0;
        this.apiLoaded = false;

        this.initYouTubePlayers();
    }

    initYouTubeAPI() {
        if (!this.apiLoaded) {
            const tagYt = document.createElement('script');
            tagYt.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tagYt, firstScriptTag);
            this.apiLoaded = true;
        }
    }

    onYouTubeIframeAPIReady(playerElementId, videoId, loop, controls, autoplay, autoInit) {
        if (!this.apiLoaded) {
            this.initYouTubeAPI();
        }

        if (typeof YT === 'undefined' || typeof YT.Player !== 'function') {
            if (this.attempts <= 3) {
                this.attempts++;
                console.log('Carregando API do YouTube...');
                setTimeout(() => {
                    this.onYouTubeIframeAPIReady(playerElementId, videoId, loop, controls, autoplay, autoInit);
                }, 600);
            }
            return;
        }

        // Pausa apenas os players que não possuem autoplay ativado
        if (!autoInit) {
            this.pauseAllPlayers();
        }

        if (!this.players[playerElementId]) {
            this.players[playerElementId] = new YT.Player(playerElementId, {
                height: '100%',
                width: '100%',
                videoId: videoId,
                playerVars: {
                    'autoplay': autoplay || autoInit ? 1 : 0,
                    'controls': controls,
                    'disablekb': 1,
                    'fs': 0,
                    'loop': loop,
                    'modestbranding': 1,
                    'showinfo': 0,
                    'playlist': loop ? videoId : undefined,
                    'rel': 0,
                    'mute': autoplay ? 1 : 0
                },
                events: {
                    'onStateChange': (event) => this.onPlayerStateChange(event, autoplay)
                }
            });
        } else {
            this.players[playerElementId].playVideo();
        }
        this.attempts = 0;
    }

    onPlayerStateChange(event, autoplay) {
        if (event.data === YT.PlayerState.PLAYING && !autoplay) {
            this.pauseAllPlayers(event.target.getIframe().id);
        }
    }

    pauseAllPlayers(exceptId = null) {
        for (let playerID in this.players) {
            const playerState = this.players[playerID].getPlayerState();
            const isAutoplay = this.players[playerID].getIframe().getAttribute('data-autoplay') === '1';

            if (playerID !== exceptId && playerState === YT.PlayerState.PLAYING && !isAutoplay) {
                this.players[playerID].pauseVideo();
                this.resetPlayerContainer(playerID);
            }
        }
    }

    resetPlayerContainer(playerID) {
        const playerIframe = document.getElementById(playerID);
        if (playerIframe) {
            const playYTContainer = playerIframe.previousElementSibling;
            if (playYTContainer && playYTContainer.classList.contains('play_yt_container')) {
                playYTContainer.style.display = 'block';
            }
        }
    }

    initYouTubePlayers() {
        document.addEventListener('DOMContentLoaded', () => {
            const playYTContainers = document.querySelectorAll('.play_yt_container');

            playYTContainers.forEach(playYTContainer => {
                const player = playYTContainer.nextElementSibling;
                const playerID = player.getAttribute('data-id');
                const playerLoop = Number(player.getAttribute('data-loop'));
                const playerControls = Number(player.getAttribute('data-controls'));
                const playerAutoplay = Number(player.getAttribute('data-autoplay'));

                playYTContainer.addEventListener('click', () => {
                    playYTContainer.style.display = 'none';
                    this.onYouTubeIframeAPIReady('player_' + playerID, playerID, playerLoop, playerControls, false, true);
                });

                if (playerAutoplay) {
                    // Atrasar o carregamento da API para vídeos com autoplay
                    setTimeout(() => {
                        this.onYouTubeIframeAPIReady('player_' + playerID, playerID, playerLoop, playerControls, playerAutoplay, true);
                    }, 1500); // Ajuste o tempo de atraso conforme necessário
                }
            });
        });
    }
}

const ytScriptsInstance = new YTScripts();
export default ytScriptsInstance;